import React, { useState, useEffect } from "react";
import "./discrepancies.css";

const DiscrepancyList = () => {
  const [search, setSearch] = useState("");
  const [discrepancies, setDiscrepancies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClaims();
  }, []);

  const fetchClaims = async () => {
    try {
      setLoading(true);
      const response = await fetch('/process_data/get-chassis-match-claims', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();
      
      if (data.success) {
        const formattedData = data.data.map(claimNumber => ({
          id: claimNumber,
          issues: 1
        }));
        
        setDiscrepancies(formattedData);
      }
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  // Function to navigate to claim landing page
  const goToClaimPage = (claimNumber) => {
    // Method 1: Using window.location (works without React Router)
    window.location.href = `/claimlanding/${claimNumber}`;
    
    // Method 2: If using hash router
    // window.location.hash = `#/claimlanding/${claimNumber}`;
    
    // Method 3: If your claim landing page is at different URL
    // window.location.href = `/claim/${claimNumber}`;
    // window.location.href = `/claim-details/${claimNumber}`;
    // window.location.href = `/claim-summary/${claimNumber}`;
  };

  const filteredDiscrepancies = discrepancies.filter((d) =>
    d.id.toLowerCase().includes(search.toLowerCase())
  );

  if (loading && discrepancies.length === 0) {
    return (
      <div className="main-card">
        <h2>All Discrepancies</h2>
        <p className="loading">Loading claims...</p>
      </div>
    );
  }

  return (
    <div className="main-card">
      <h2>All Discrepancies</h2>
      <input
        type="text"
        placeholder="Search"
        className="search-bar"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="card-container">
        {filteredDiscrepancies.length > 0 ? (
          filteredDiscrepancies.map((discrepancy, index) => (
            <div className="box" key={index}>
              <div className="box-content">
                <p className="claim-id">Claim {discrepancy.id}</p>
                {/* <p className="issues">⚠️ {discrepancy.issues} Issues found</p> */}
              </div>
              <button 
                className="review-button"
                onClick={() => goToClaimPage(discrepancy.id)}
              >
                Review
              </button>
            </div>
          ))
        ) : (
          <p className="no-results">
            {search 
              ? `No claims found matching "${search}"` 
              : 'No discrepancies found'
            }
          </p>
        )}
      </div>
    </div>
  );
};

export default DiscrepancyList;